<template>
  <component
    :is="tag"
    :class="loadingClass"
    :primary="primary"
    :secondary="secondary"
    :danger="danger"
  >
    <slot/>
  </component>
</template>

<script>
import ButtonMixin from '@/Mixins/ButtonMixin'

export default {
  mixins: [ButtonMixin],

  name: "LoadingButton",

  props: {
    tag: {
      type: String,
      default: "button"
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    loadingClass() {
      return {
        ...this.btnClass,
        "base-spinner cursor-not-allowed": this.loading,
      }
    },
  }
};
</script>
